import { createStore as _createStore, applyMiddleware, compose, combineReducers } from 'redux'
import thunk from 'redux-thunk'
import { routerReducer, routerMiddleware } from 'react-router-redux'
import history from './history'

export function buildRootReducer (allReducers) {
  return combineReducers(Object.assign({}, allReducers, { routing: routerReducer }))
}

export function createStore (reducers) {
  const initialState = window.initialReduxState

  // Build middleware. These are functions that can process the actions before they reach the store.
  // If devTools is installed, connect to it
  const devToolsExtension = window && window.__REDUX_DEVTOOLS_EXTENSION__
  const createStoreWithMiddleware = compose(
    applyMiddleware(thunk, routerMiddleware(history)),
    devToolsExtension ? devToolsExtension() : (next) => next)(_createStore)

  // Combine all reducers and instantiate the app-wide store instance
  const allReducers = buildRootReducer(reducers)
  const store = createStoreWithMiddleware(allReducers, initialState)
  return store
}



// WEBPACK FOOTER //
// ./src/utils/createStore.js